"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areArraysEquivalent = areArraysEquivalent;
function areArraysEquivalent(firstArray, secondArray) {
    if (firstArray.length !== secondArray.length) {
        return false;
    }
    const firstArraySortedString = firstArray
        .map((item) => JSON.stringify(item))
        .sort()
        .join("|");
    const secondArraySortedString = secondArray
        .map((item) => JSON.stringify(item))
        .sort()
        .join("|");
    return firstArraySortedString === secondArraySortedString;
}
//# sourceMappingURL=are-arrays-equivalent.js.map